import { SLOTS } from './slots.js'

// App users — the largest admin list. Interactive row actions (award, edit,
// archive, Stripe, subscription enroll/pause/resume/cancel) live in the page's
// `actions` snippet; this config owns the read-only display columns only.
// Phone (the login credential) is the at-a-glance identifier; email, referrals,
// programs and redemption stats live on the detail page. The avatar opens the
// lightbox (only the name links), where manage_social admins can change it.
// Membership reads the server's membership_label ("Canceled: Cancels <date>" /
// "Paused: Resumes <date>", like the old CMS) over the status color; the Stripe
// customer/subscription links are row actions.
export default {
  key: 'user',
  label: 'User',
  icon: 'users',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'icon_image.image_url', renderer: 'avatar', labelField: 'name', link: 'url', lightbox: true },
    { slot: SLOTS.STATUS, field: 'current_subscription.status', label: 'Membership', renderer: 'state_badge', domain: 'subscription', labelField: 'membership_label' },
    { slot: SLOTS.METADATA, field: 'phone', label: 'Phone' },
    { slot: SLOTS.METADATA, field: 'social_logins', label: 'Social Login' },
    { slot: SLOTS.METADATA, field: 'points', label: 'Store Points', renderer: 'points', unit: 'pts', align: 'right' },
    { slot: SLOTS.TEMPORAL, field: 'created_at', label: 'Created', renderer: 'date' }
  ],
  empty: { icon: 'users', message: 'No users found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.STATUS] }
}
